<template>
  <div id="documentsWrapper">
    <label class="label">Documenten bij dit onderwerp</label>

    <div v-for="(doc, index) in documents" class="box">
      <div class="is-pulled-right">
        <span class="icon has-text-info" @click="editDoc(doc.id)">
          <i class="fas fa-pen"></i>
        </span>

        <span class="icon has-text-danger" @click="removeDoc(doc)">
          <i class="fas fa-times-circle"></i>
        </span>
      </div>

      <article class="media">
        <p>
          <strong>{{ doc.name }}</strong>
          <br>
          {{ doc.description }}
        </p>
      </article>
    </div>

    <button class="button" type="button" @click="editDoc(false)">Document toevoegen</button>

    <document-edit :itemId="itemId"></document-edit>
  </div>
</template>

<script>
  import { bus } from '@/main'
  import axios from 'axios'
  import DocumentEdit from './DocumentEdit'

  export default {
    components: {
      'document-edit': DocumentEdit
    },
    props: ['itemId', 'documents'],
    methods: {
      editDoc (id) {
        bus.$emit('editDoc', { id: id })
      },
      removeDoc (doc) {
        this.loading = true

        axios
          .delete(`/documents/${doc.id}`)
          .then(response => {
            this.loading = false
            this.documents.$remove(doc)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/documents/Documents.vue